import { render, staticRenderFns } from "./LoldocupHome.vue?vue&type=template&id=7f83a95a&"
import script from "./LoldocupHome.vue?vue&type=script&lang=js&"
export * from "./LoldocupHome.vue?vue&type=script&lang=js&"
import style0 from "./LoldocupHome.vue?vue&type=style&index=0&id=7f83a95a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports